/* eslint-disable react/no-unescaped-entities */
import cobweb from "@/assets/images/cobweb.webp";
import FundingRegionAngel from "@/components/chart/FundingRegionAngel";
import InvestmentChart from "@/components/chart/Investment";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import useWindowSize from "@/hooks/useWindowSize";
import { gsap } from "gsap/dist/gsap";
import Image from "next/legacy/image";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
// import { Tooltip } from "react-tooltip";
import LucidMascot from "@/assets/images/lucid-mascot.png";
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/components/ui/hover-card";

import useAuth from "@/hooks/auth";
import {
  BuildingOffice,
  CircleNotch,
  Info,
  MagnifyingGlass,
  Pencil,
  Presentation,
  UserPlus,
  WarningCircle,
} from "@phosphor-icons/react";
import {
  Cardholder,
  Globe,
  Heart,
  MapPin,
  Pen,
  Plus,
  Receipt,
  Rocket,
  SealCheck,
  X,
  GenderFemale,
} from "@phosphor-icons/react/dist/ssr";
import dynamic from "next/dynamic";
import Link from "next/link";

import PlaceholderLogo from "@/assets/images/lucidity-placeholder.png";
import StartupModalDetail from "@/components/StartupModalDetail";
import Layout from "@/components/elements/Layout";
import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import {
  archivePortfolios,
  getAccessByVcId,
  getInvestmentByFundingType,
  getInvestmentByCurrentStage,
  getInvestmentByRegion,
  getInvestmentByYear,
  getInvestorContents,
  getInvestorDetail,
  getInvestorEpisodes,
  getInvestorPortfolios,
  getInvestorRelated,
  getPortfolioData,
  getVCPageByVCId,
  restoreArchivedPortfolios,
  searchInvestor,
  trackVCAccessCounting,
  unVerifyPortfolios,
  verifyPortfolios,
} from "@/services/api/VentureCapital";
import formatNumber from "@/utils/formatNumber";
import { useRouter } from "next/router";

import AppContext from "@/AppContext";
import { claimVCPopup, loginPopup, userAtom } from "@/Atoms";
import LockedContent from "@/components/LockedContent";
import RelatedContentSidebar from "@/components/RelatedContentSidebar";
import TwitterFeed from "@/components/TwitterFeed";
import WishlistAddNew from "@/components/WishlistAddNew";
import SubNavigation from "@/components/elements/SubNavigation";
import { AddStartup } from "@/components/investor/add-startup";
import ReviewStartup from "@/components/investor/review-startup";
import PortfolioCard from "@/components/items/PortfolioCard";
import { Badge } from "@/components/ui/badge";
import { Checkbox } from "@/components/ui/checkbox";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Textarea } from "@/components/ui/textarea";
import { useCountry } from "@/hooks/useCountry";
import { useFundingType } from "@/hooks/useFundingType";
import { useSector } from "@/hooks/useSector";
import { getDiversityInclusionByVc } from "@/services/api/DiversityInclusion";
import { searchStartup } from "@/services/api/Startup";
import { getTestimonialsByVc } from "@/services/api/Testimonial";
import { getVcFundsByVcId } from "@/services/api/VCFund";
import { INVESTOR_TYPES } from "@/utils/constants";
import { CONTENT_TYPES } from "@/utils/content";
import unslugify from "@/utils/unslugify";
import dayjs from "dayjs";
import { ScrollToPlugin } from "gsap/dist/ScrollToPlugin";
import { useAtom } from "jotai";
import debounce from "lodash/debounce";
import SectorsChart from "@/components/chart/Sectors";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuPortal,
  DropdownMenuSeparator,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { getVCSocialMedia } from "@/services/api/VCSocialMedia";
import { fitIn } from "@/utils/imageHandler";
import ApplyFunding from "@/components/modal/ApplyFunding";
const PortfolioMap = dynamic(
  () => import("@/components/map/PortfolioMap.jsx"),
  {
    ssr: false,
  },
);
import {
  getAvatarByIdOrDefault,
  getPlaceholderByGender,
} from "@/utils/avatarOptions";
import NeutralPlaceholder from "@/assets/images/placeholders/neutral-profile.svg";
import { avatarOptions } from "@/utils/avatarOptions";

gsap.registerPlugin(ScrollToPlugin);

// Add this import at the top with other imports
import PublishSuccess from "@/components/PublishSuccess";

// Add these imports at the top with other imports
import MalePlaceholder from "@/assets/images/placeholders/male-profile.svg";
import FemalePlaceholder from "@/assets/images/placeholders/female-profile.svg";

const getPublicName = (item) => item?.country_name || item?.name;

const normalizePublicNames = (items = []) =>
  (Array.isArray(items) ? items : []).map(getPublicName).filter(Boolean);

const formatTrackRecordItems = (investor) => {
  const items = [];
  const startupInvestments = Number(investor?.number_startups_investments);
  const linkedDeals = Number(investor?.number_deal_linked);
  const exits = Number(investor?.number_of_exits);
  const coInvestments = Number(investor?.number_angel_co_investments);
  const groupInvestments = Number(investor?.number_angel_group_investments);
  const establishedYear = Number(investor?.year_established);

  if (Number.isFinite(startupInvestments) && startupInvestments > 0) {
    items.push(`${formatNumber(startupInvestments)} startup investments`);
  }
  if (Number.isFinite(linkedDeals) && linkedDeals > 0) {
    items.push(`${formatNumber(linkedDeals)} linked deals`);
  }
  if (Number.isFinite(exits) && exits > 0) {
    items.push(`${formatNumber(exits)} exits`);
  }
  if (Number.isFinite(coInvestments) && coInvestments > 0) {
    items.push(`${formatNumber(coInvestments)} angel co-investments`);
  }
  if (Number.isFinite(groupInvestments) && groupInvestments > 0) {
    items.push(`${formatNumber(groupInvestments)} angel group investments`);
  }
  if (Number.isFinite(establishedYear) && establishedYear > 0) {
    items.push(`Established in ${establishedYear}`);
  }

  return items;
};

const getAngelSuperpowerSections = (investor) => {
  const networkAccess = normalizePublicNames(investor?.markets_of_interest);
  const sectorsOfInterest = normalizePublicNames(investor?.sectors_of_interest);
  const trackRecord = formatTrackRecordItems(investor);

  const prefs = investor?.pitch_preferences_public || {};
  const prefSectorNames = normalizePublicNames(prefs.sectors);
  const prefStageNames = normalizePublicNames(prefs.stages);
  const prefMarketNames = [
    ...normalizePublicNames(prefs.regions),
    ...normalizePublicNames(prefs.countries),
  ];

  const preferenceCopy = (label, openToAny, names) => {
    if (openToAny && names.length > 0) {
      return `${label} agnostic, with preferred references:`;
    }
    if (openToAny || names.length === 0) return `${label} Agnostic`;
    return "Preferred references:";
  };

  const hasPrefSignal = (openToAny, names) => openToAny || names.length > 0;

  return [
    investor?.superpower
      ? {
          key: "superpower",
          title: "What I Bring",
          icon: Rocket,
          text: investor.superpower,
        }
      : null,
    networkAccess.length > 0
      ? {
          key: "network",
          title: "Network Access",
          icon: Globe,
          tags: networkAccess,
        }
      : null,
    sectorsOfInterest.length > 0
      ? {
          key: "sectors",
          title: "What I Care About",
          icon: Heart,
          tags: sectorsOfInterest,
        }
      : null,
    trackRecord.length > 0
      ? {
          key: "track-record",
          title: "Track Record",
          icon: SealCheck,
          text: trackRecord.join(". "),
        }
      : null,
    hasPrefSignal(prefs.sectors_open_to_any, prefSectorNames)
      ? {
          key: "pref-sectors",
          title: "Sectors of Interest",
          icon: Heart,
          caption: preferenceCopy(
            "Sector",
            prefs.sectors_open_to_any,
            prefSectorNames,
          ),
          tags: prefSectorNames,
        }
      : null,
    hasPrefSignal(prefs.markets_open_to_any, prefMarketNames)
      ? {
          key: "pref-markets",
          title: "Markets",
          icon: Globe,
          caption: preferenceCopy(
            "Market",
            prefs.markets_open_to_any,
            prefMarketNames,
          ),
          tags: prefMarketNames,
        }
      : null,
    hasPrefSignal(prefs.stages_open_to_any, prefStageNames)
      ? {
          key: "pref-stages",
          title: "Stage Focus",
          icon: Rocket,
          caption: preferenceCopy(
            "Stage",
            prefs.stages_open_to_any,
            prefStageNames,
          ),
          tags: prefStageNames,
        }
      : null,
    prefs.support_female_founders
      ? {
          key: "pref-female",
          title: "Actively Supports Female Founders",
          icon: GenderFemale,
        }
      : null,
  ].filter(Boolean);
};

const AngelSuperpowerPanel = ({
  sections,
  isOwner = false,
  angelAccountHref = "/account/angel",
  className = "",
}) => {
  if (!sections.length) {
    if (!isOwner) return null;

    return (
      <div
        className={`relative z-10 p-4 pt-3 text-white bg-gradient-to-tl from-white/5 to-white/15 ${className}`}
      >
        <p className='text-lg font-semibold'>My Superpower</p>
        <div className='pt-5 mt-3 space-y-3 text-xs text-white/60 border-t border-dashed border-white/20'>
          <p>
            Set your pitch preferences so founders know what you care about and
            so incoming pitches are scored against your criteria.
          </p>
          <Link href={angelAccountHref}>
            <Button
              size='sm'
              variant='outline'
              className='w-full text-xs bg-transparent border-white/20'
            >
              Set Pitch Preferences
            </Button>
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div
      className={`relative z-10 p-4 pt-3 text-white bg-gradient-to-tl from-white/5 to-white/15 ${className}`}
    >
      <p className='text-lg font-semibold'>My Superpower</p>
      <div className='pt-5 -my-3 divide-y divide-white/20 divide-dashed'>
        {sections.map((section, index) => {
          const Icon = section.icon;

          return (
            <div
              key={section.key}
              className={`flex flex-col gap-3 py-3 ${
                index === 0 ? "border-t border-dashed border-white/20" : ""
              }`}
            >
              <p className='flex items-center gap-2.5 font-medium shrink-0'>
                <span className='inline-flex items-center justify-center bg-white rounded-full text-background size-7'>
                  <Icon weight='bold' className='size-4' />
                </span>
                {section.title}
              </p>
              {section.text && (
                <p className='text-xs whitespace-pre-line text-white/50'>
                  {section.text}
                </p>
              )}
              {section.caption && (
                <p className='text-xs text-white/50'>{section.caption}</p>
              )}
              {section.tags?.length > 0 && (
                <div className='flex flex-wrap gap-1'>
                  {section.tags.map((tag) => (
                    <span
                      key={tag}
                      className='h-auto px-2.5 py-0.5 text-[11px] font-medium text-white border-none rounded-full bg-white/10'
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

const VentureCapitalDetail = ({
  investor,
  investorId,
  related,
  portfolios: _portfolios,
  investmentsByYear: _investmentsByYear,
  investmentsByRegion: _investmentsByRegion,
  investmentsByFundingType: _investmentsByFundingType,
  startup_sectors: _startup_sectors,
  top_n_sectors: _top_n_sectors,
  vc_startup_news: _vc_startup_news,
}) => {
  const containerRef = useRef(null);
  const [showMap, setShowMap] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [padding, setPadding] = useState(0);
  const [foundIds, setFoundIds] = useState([]);
  const [portfolioData, setPortfolioData] = useState({
    archived: [],
    verified: [],
  });
  const [startups, setStartups] = useState([]);
  const [currentPage, setCurrentPage] = useState(
    _portfolios?.current_page || 1,
  );
  const [totalResult, setTotalResult] = useState(_portfolios?.total || 0);
  const [lastPage, setLastPage] = useState(_portfolios?.last_page || 0);
  const [startupInput, setStartupInput] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [selectedStartup, setSelectedStartup] = useState(null);
  const [counter, setCounter] = useState(1);
  const [loadMoreSector, setLoadMoreSector] = useState(false);
  const [userClaimData, setUserClaimData] = useState(null);
  const [locked, setLocked] = useState(false);
  const [loadingUpload, setLoadingUpload] = useState(false);
  const [checkedStartups, setCheckedStartups] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [openLoginPopup, setOpenLoginPopup] = useAtom(loginPopup);
  const [openClaimVCPopup, setOpenClaimVCPopup] = useAtom(claimVCPopup);
  const [hasAccess, setHasAccess] = useState(false);
  const [searchInvestorQuery, setSearchInvestorQuery] = useState("");
  const [loadingPortfolios, setLoadingPortfolios] = useState(false);
  const [userState, setUserState] = useAtom(userAtom);
  const [reach_limit, setReachLimit] = useState(false);
  const [news, setNews] = useState([]);
  const [spotlights, setSpotlights] = useState([]);
  const [opinions, setOpinions] = useState([]);
  const [articles, setArticles] = useState([]);
  const [episodes, setEpisodes] = useState([]);
  const [openWishlistAction, setOpenWishlistAction] = useState(false);
  const [isAddDialogOpen, setIsAddDialogOpen] = useState(false);
  const [vcFunds, setVCFunds] = useState([]);
  const [diversityInclusion, setDiversityInclusion] = useState(null);
  const [portfolios, setportfolios] = useState([]);
  const [investmentsByYear, setinvestmentsByYear] =
    useState(_investmentsByYear);
  const [investmentsByRegion, setinvestmentsByRegion] =
    useState(_investmentsByRegion);
  const [investmentsByFundingType, setinvestmentsByFundingType] = useState(
    _investmentsByFundingType,
  );
  const [startup_sectors, setstartup_sectors] = useState(_startup_sectors);
  const [top_n_sectors, settop_n_sectors] = useState(_top_n_sectors);
  const [vc_startup_news, setvc_startup_news] = useState(_vc_startup_news);
  const [countrySearch, setCountrySearch] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [stageSearch, setStageSearch] = useState("");
  const [sectorSearch, setSectorSearch] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [searchSectorQuery, setSearchSectorQuery] = useState("");
  const { countries } = useCountry({ searchStartupDropdown: true });
  const { data: sectors } = useSector({ dropdown: true });
  const { data: stages } = useFundingType({ searchVCDropdown: true });
  const [temps, setTemps] = useState({
    countries: [],
    sectors: [],
    stages: [],
  });

  const filteredCountries = countries.filter((country) =>
    country.country_name.toLowerCase().includes(searchQuery.toLowerCase()),
  );

  const filteredStages = stages.filter((stage) =>
    stage.name.toLowerCase().includes(stageSearch.toLowerCase()),
  );

  const filteredSectors = sectors.filter((sector) =>
    sector.name.toLowerCase().includes(sectorSearch.toLowerCase()),
  );

  const handleChangeFilter = (name, event, data) => {
    const checked = event?.target?.checked || event;
    let arr = [...temps[name]];
    if (checked) {
      arr.push(data);
    } else {
      arr = arr.filter((item) => item.id !== data.id);
    }
    const obj = { ...temps };
    obj[name] = arr;

    setTemps(obj);

    onSearchPortfolios(null, obj);
  };

  const getEpisodes = async () => {
    try {
      const response = await getInvestorEpisodes(investorId, {
        params: {
          per_page: 1000,
        },
      });

      const data = response.data;

      setEpisodes(data);
    } catch (error) {
      console.error("Error fetching related contents", error);
    }
  };

  const getRelatedContents = async () => {
    try {
      const response = await getInvestorContents(investorId, {
        params: {
          per_page: 1000,
        },
      });

      const data = response.data;

      if (data["Spotlights"]) {
        setSpotlights(data["Spotlights"]);
      }
      if (data["Opinions"]) {
        setOpinions(data["Opinions"]);
      }
      if (data["News"]) {
        setNews(data["News"]);
      }
      if (data["Articles"]) {
        setArticles(data["Articles"]);
      }

      if (data["Podcast Episodes"]) {
        setEpisodes(data["Podcast Episodes"]);
      }
    } catch (error) {
      console.error("Error fetching related contents", error);
    }
  };

  // Create a debounced search function using useCallback
  const debouncedSearch = useCallback(
    debounce(async (value) => {
      const res = await searchInvestor({
        params: {
          keyword: value,
        },
      });
      setSearchResults(res.data.data);
    }, 300), // 300ms delay
    [], // Empty dependency array since we don't want to recreate this function
  );

  const handleInvestorSearch = (value) => {
    setSearchInvestorQuery(value);
    debouncedSearch(value);
  };

  const router = useRouter();
  const { user } = useAuth();

  const screenSize = useWindowSize();

  const currentPath = router.asPath;
  const {
    state,
    userVCWishlistIds,
    onRemoveVCWishlist,
    getWishlistCategories,
    wishlistCategories,
    setWishlist,
    addWishlistCategory,
  } = useContext(AppContext);
  const { planSubscription } = state;
  const checkAllRef = useRef(null);

  const hasSubscription =
    planSubscription && planSubscription.has_active_subscription;

  function toLogin() {
    setOpenLoginPopup(true);
    localStorage.setItem("nextStep", "claimVCPopup");
  }

  function toggleMap() {
    if (showMap) {
      setShowMap(false);
    } else {
      setShowMap(true);
    }
  }

  const addStartupId = (id) => {
    setCheckedStartups((prevStartups) => {
      if (prevStartups.includes(id)) {
        // If the id already exists, remove it from the array
        return prevStartups.filter((startup) => startup !== id);
      } else {
        // checkAllRef.current.setAttribute('aria-checked', 'false');
        // If the id doesn't exist, add it to the array
        return [...prevStartups, id];
      }
    });
  };

  const getVCClaimUserData = async () => {
    setUserClaimData(null);
    const response = await getVCPageByVCId(investorId, {
      params: {
        status: "pending",
      },
    });

    if (response.data) {
      setUserClaimData(response.data);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      let containerWidth = containerRef.current.offsetWidth - 32;
      if (screenSize.width > 1024) {
        setPadding((screenSize.width - containerWidth) / 2);
      } else {
        setPadding(0);
      }
    }, 200);
  }, [screenSize]);

  const onSearchPortfolios = async (e, filters) => {
    e?.preventDefault();
    if (!startupInput && !filters) {
      return setStartups(portfolios?.data || []);
    }
    setLoadingPortfolios(true);
    const params = {
      keyword: startupInput || "*",
      per_page: 250,
      vc_id: investorId,
      include_unpublished: true,
    };

    if (filters?.sectors && filters.sectors.length > 0) {
      params["sectors"] = filters
        ? filters.sectors.map((s) => s.id).join(",")
        : "";
    }

    if (filters?.countries && filters.countries.length > 0) {
      params["countries"] = filters
        ? filters.countries.map((s) => s.id).join(",")
        : "";
    }

    if (filters?.stages && filters.stages.length > 0) {
      params["stages"] = filters
        ? filters.stages.map((s) => s.id).join(",")
        : "";
    }

    try {
      const res = await searchStartup({
        params,
      });
      if (res?.data?.data && res.data.data.length > 0) {
        const ids = res.data.data.map((v) => v.id);
        setFoundIds(ids);
        setStartups(portfolios?.data?.filter((prt) => ids.includes(prt.id)));
      } else {
        setStartups([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingPortfolios(false);
    }
  };

  const loadMore = async () => {
    try {
      const res = await getInvestorPortfolios(investorId, {
        params: {
          page: currentPage + 1,
          per_page: 4,
        },
      });
      setCurrentPage(res.data.current_page);
      setStartups((curr) => [...curr, ...res.data.data]);
    } catch (error) {}
  };

  const handleSelectStartup = (item) => {
    setSelectedStartup(item);
    setIsOpen(true);
  };

  const fetchPortData = async () => {
    const portfolioDataResponse = await getPortfolioData(investorId);
    setPortfolioData(portfolioDataResponse.data);

    const filteredStartups = _portfolios?.data?.filter(
      (p) => !portfolioDataResponse.data.archived.includes(p.id),
    );
    setStartups(filteredStartups);
  };

  const fetchTestimonials = async () => {
    try {
      const response = await getTestimonialsByVc(investorId);
      if (response?.data.length) {
        setTestimonials(response.data);
      }
    } catch (error) {}
  };

  const checkVcAccess = async () => {
    try {
      const res = await getAccessByVcId(investorId);
      console.log(res);
      if (res && res.data && res.data.success) {
        setHasAccess(res.data.success);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const syncInvestmentChartData = () => {
    setinvestmentsByYear(_investmentsByYear || []);
    setinvestmentsByRegion(_investmentsByRegion || []);
    setinvestmentsByFundingType(_investmentsByFundingType || []);
  };

  useEffect(() => {
    const fetchData = async () => {
      setCounter(0);
      setCounter((state) => state + 1);
      await getVCClaimUserData();
      setCurrentPage(portfolios?.current_page);
      setTotalResult(portfolios?.total);
      setLastPage(portfolios?.last_page);

      await fetchPortData();
      await fetchTestimonials();
      await fetchVcFunds();
      await fetchDiversityInclusionByVc();
      setportfolios(_portfolios);
      setinvestmentsByYear(_investmentsByYear);
      setinvestmentsByRegion(_investmentsByRegion);
      setinvestmentsByFundingType(_investmentsByFundingType);
      setstartup_sectors(_startup_sectors);
      settop_n_sectors(_top_n_sectors);
      setvc_startup_news(_vc_startup_news);

      if (localStorage.getItem("nextStep") === "claimVCPopup") {
        if (router.pathname !== "/auth/google") {
          setOpenClaimVCPopup(true);
          localStorage.removeItem("nextStep");
        }
      }

      syncInvestmentChartData();

      await checkVcAccess();
      // await getRelatedContents();
      await fetchSocialMedia();
    };

    fetchData();

    // Cleanup function to reset state values
    return () => {
      setShowMap(false);
      setIsEdit(false);
      setPadding(0);
      setFoundIds([]);
      setPortfolioData({
        archived: [],
        verified: [],
      });
      setStartups([]);
      setCurrentPage(1);
      setTotalResult(0);
      setLastPage(0);
      setStartupInput("");
      setIsOpen(false);
      setSelectedStartup(null);
      setCounter(1);
      setLoadMoreSector(false);
      setUserClaimData(null);
      setLocked(false);
      setLoadingUpload(false);
      setCheckedStartups([]);
      setTestimonials([]);
      setOpenLoginPopup(false);
      setOpenClaimVCPopup(false);
      setHasAccess(false);
      setSearchInvestorQuery("");
      setLoadingPortfolios(false);
      setUserState(null);
      setReachLimit(false);
      setNews([]);
      setSpotlights([]);
      setEpisodes([]);
      setOpenWishlistAction(false);
      setIsAddDialogOpen(false);
      setVCFunds([]);
      setDiversityInclusion(null);
      setportfolios(null);
      setinvestmentsByYear([]);
      setinvestmentsByRegion([]);
      setinvestmentsByFundingType([]);
      setstartup_sectors([]);
      settop_n_sectors([]);
      setvc_startup_news([]);
    };
  }, [investorId, router.query.slug, _portfolios]);

  useEffect(() => {
    fetchMeteredContent();
    getEpisodes();

    syncInvestmentChartData();
  }, [investorId, user, hasAccess]);

  // Keep the other useEffect for setting other data
  useEffect(() => {
    setportfolios(_portfolios);
    setstartup_sectors(_startup_sectors);
    settop_n_sectors(_top_n_sectors);
    setvc_startup_news(_vc_startup_news);
  }, [_portfolios, _startup_sectors, _top_n_sectors, _vc_startup_news]);

  const addAll = () => {
    const isChecked = checkAllRef.current.getAttribute("aria-checked");
    if (isChecked !== "true") {
      setCheckedStartups([]);
      setCheckedStartups(startups?.map((s) => s.id));
    } else {
      setCheckedStartups([]);
    }
  };

  const onVerify = async ({ onClose }) => {
    try {
      const response = await verifyPortfolios(investorId, {
        startup_ids: checkedStartups,
      });
      onClose();
      fetchPortData();
    } catch (error) {}
  };

  const onArchive = async ({ onClose }) => {
    try {
      const response = await archivePortfolios(investorId, {
        startup_ids: checkedStartups,
      });
      onClose();
      fetchPortData();
    } catch (error) {}
  };

  const onUnVerify = async ({ onClose }) => {
    try {
      const response = await unVerifyPortfolios(investorId, {
        startup_ids: checkedStartups,
      });
      onClose();
      fetchPortData();
    } catch (error) {}
  };

  const onRestore = async ({ onClose }) => {
    try {
      const response = await restoreArchivedPortfolios(investorId, {
        startup_ids: checkedStartups,
      });
      onClose();
      fetchPortData();
    } catch (error) {}
  };

  const fetchMeteredContent = async () => {
    if (user) {
      // Skip API call for admin-team, read-access users, owners, or users with special access
      if (
        user.roles === "admin-team" ||
        user.roles === "read-access" ||
        investor.owner_id == user?.id ||
        hasAccess
      ) {
        setReachLimit(false);
        setLocked(false);
        // Only grant edit permissions to admin-team, owners, or users with special access (NOT read-access)
        if (
          hasAccess ||
          user.roles === "admin-team" ||
          investor.owner_id == user?.id
        ) {
          setIsEdit(true);
        }
      } else {
        // For regular users, track access and check limits
        try {
          const response = await trackVCAccessCounting(investorId, {
            ip_address: localStorage.getItem("lctd-ia"),
            user_id: user?.id,
            user_email: user?.email,
          });
          setReachLimit(response.data.reach_limit);
          setLocked(response.data.reach_limit);
        } catch (error) {
          console.log(error);
          setLocked(true);
        }
      }
    } else {
      setLocked(true);
    }
  };

  const handleMyWishlistClick = (event, cat_id, vc_id) => {
    event.stopPropagation();
    setWishlist(cat_id, vc_id, 2);
  };

  const handleChange = (e) => {
    if (!user) {
      return setOpenLoginPopup(true);
    }
    getWishlistCategories();
    setOpenWishlistAction(e);
  };

  async function fetchVcFunds() {
    try {
      const response = await getVcFundsByVcId(investorId);
      setVCFunds(response.data.data);
    } catch (error) {
      console.error("Error fetching VC Funds:", error);
    }
  }

  const fetchDiversityInclusionByVc = async () => {
    try {
      const response = await getDiversityInclusionByVc(investorId);
      setDiversityInclusion(response.data);
    } catch (error) {
      console.error("Error fetching VC Diversity Inclusion by VC ID:", error);
    }
  };

  const onClearFilter = () => {
    const obj = {
      countries: [],
      sectors: [],
      stages: [],
    };
    setTemps(obj);
    onSearchPortfolios(null, null);
  };

  const removeFilter = (e, name) => {
    e.stopPropagation();
    const obj = { ...temps };
    obj[name] = [];
    setTemps(obj);
    onSearchPortfolios(null, obj);
  };

  const fetchSocialMedia = async () => {
    try {
      const response = await getVCSocialMedia(investorId);
      const data = response.data.data;
      if (data) {
        const platforms = {
          linkedin: "",
          x: "",
          facebook: "",
          instagram: "",
          tiktok: "",
        };

        data.forEach((item) => {
          platforms[item.platform] = item.url;
        });

        setSocialMedias(platforms);
      }
    } catch (error) {
      console.error("Error fetching social media:", error);
    }
  };

  const [socialMedias, setSocialMedias] = useState({});

  const scrollToPortfolio = (e) => {
    e.preventDefault();
    const element = document.getElementById("portfolio-startups");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  // Add state for success modal
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  // Add this useEffect to handle the success parameter
  useEffect(() => {
    if (router.query.success === "true") {
      setShowSuccessModal(true);
    }
  }, [router.query]);

  const handleCloseSuccessModal = () => {
    setShowSuccessModal(false);
    // Clean up the URL without redirecting
    router.replace(`/angel-investors/${router.query.slug}`, undefined, {
      shallow: true,
    });
  };

  const canShowAngelSuperpower =
    process.env.NEXT_PUBLIC_ENV !== "production";
  const angelSuperpowerSections = getAngelSuperpowerSections(investor);
  const isAngelOwner = !!(
    investor?.owner_id && user?.id && investor.owner_id == user.id
  );
  const showAngelSuperpower =
    canShowAngelSuperpower &&
    (angelSuperpowerSections.length > 0 || isAngelOwner);

  return (
    <Layout
      className='text-white/70'
      title={investor.name}
      meta_title={investor.name + " Investor Profile | Lucidity Insights"}
      description={`Access ${investor.name}'s investments data & insights, portfolio, performance, and more. Join Lucidity Insights for the full profile.`}
      meta_image={fitIn(investor.logo_url, 400)}
    >
      <SubNavigation title={investor.name}>
        {userVCWishlistIds && (
          <div className='flex items-center text-white gap-x-1'>
            {userVCWishlistIds.includes(investor.id) ? (
              <button
                type='button'
                onClick={(e) => onRemoveVCWishlist(e, investor.id)}
              >
                <Heart weight='fill' color='red' className='text-2xl' />
              </button>
            ) : (
              <DropdownMenu
                open={openWishlistAction}
                onOpenChange={handleChange}
              >
                <DropdownMenuTrigger asChild>
                  <button type='button'>
                    <Heart weight='bold' className='text-2xl' />
                  </button>
                </DropdownMenuTrigger>
                <DropdownMenuContent className='w-[200px] max-h-[300px] overflow-y-auto'>
                  <DropdownMenuLabel className='text-xs font-medium text-white/40'>
                    Add to Watchlist
                  </DropdownMenuLabel>
                  <DropdownMenuItem
                    onClick={(event) => {
                      event.stopPropagation(); // Prevent click event from bubbling up
                      setIsAddDialogOpen(true); // Open the add dialog
                      setOpenWishlistAction(false);
                    }}
                  >
                    <Plus weight='bold' className='mr-2' />
                    <span>Create New Watchlist</span>
                  </DropdownMenuItem>
                  <DropdownMenuSeparator />
                  <DropdownMenuItem
                    onClick={(e) => handleMyWishlistClick(e, null, investor.id)}
                  >
                    My Watchlist
                  </DropdownMenuItem>
                  {hasSubscription &&
                    wishlistCategories?.map((cat) => (
                      <DropdownMenuItem
                        key={cat.id}
                        onClick={(e) =>
                          handleMyWishlistClick(e, cat.id, investor.id)
                        }
                      >
                        {cat.name}
                      </DropdownMenuItem>
                    ))}
                </DropdownMenuContent>
              </DropdownMenu>
            )}
          </div>
        )}
      </SubNavigation>

      <div className='relative'>
        {!!investor.is_inactive && (
          <>
            <iframe
              src='https://lottie.host/embed/1b8e336d-69ff-444e-b28a-1d502cf69da2/KiwohUVCTL.json'
              className='absolute top-0 z-10 -translate-x-1/2 left-1/2 lg:translate-x-0 lg:-left-8'
            ></iframe>
            <div className='absolute top-0 lg:-top-6 right-0 h-36 lg:h-80 aspect-[337/84]'>
              <Image src={cobweb} alt='' layout='fill' />
            </div>
            <div className='fixed z-10 flex items-center gap-1.5 px-4 pl-3 py-2 text-sm -translate-x-1/2 bg-white rounded-lg bottom-4 text-background left-1/2'>
              <Info
                weight='fill'
                className='flex-shrink-0 w-4 h-4 text-orange-600'
              />
              <p className='opacity-80 whitespace-nowrap'>
                This venture capital is no longer active
              </p>
            </div>
          </>
        )}
        <div className={!!investor.is_inactive ? "grayscale" : ""}>
          <div>
            <div className='relative -mt-14 bg-gradient-to-r from-[#CD4F4F] to-[#571FFF] pt-20 lg:pt-24'>
              <div className='absolute bottom-0 hidden w-full h-32 lg:block lg:h-14 bg-background'></div>
              <div ref={containerRef} className='container'>
                <div className='relative flex flex-col items-center justify-between lg:flex-row lg:flex-nowrap lg:space-x-8'>
                  <div className='flex flex-col items-center gap-5 mb-6 lg:gap-7 lg:items-start lg:flex-row lg:mb-0'>
                    <button
                      type='button'
                      onClick={() =>
                        document.getElementById("hiddenFileInputSingle").click()
                      }
                      disabled
                      className=''
                    >
                      <div className='relative flex items-center justify-center flex-shrink-0 overflow-hidden bg-white rounded-full h-28 lg:h-48 aspect-square'>
                        {loadingUpload ? (
                          <CircleNotch className='w-16 h-16 text-slate-500 animate-pulse' />
                        ) : (
                          <Image
                            src={
                              investor.logo_url
                                ? fitIn(investor.logo_url, 400)
                                : investor.avatar
                                  ? getAvatarByIdOrDefault(investor.avatar)
                                  : getPlaceholderByGender(investor.gender)
                            }
                            layout='fill'
                            objectFit='cover'
                            alt={`Logo of ${investor.name}`}
                          />
                        )}
                        {((investor.owner_id &&
                          investor.owner_id == user?.id) ||
                          user?.roles === "admin-team" ||
                          hasAccess) && (
                          <span className='absolute inset-0 flex items-center justify-center w-full h-full text-xl transition-all scale-150 opacity-0 group-hover:scale-100 group-hover:opacity-100 group-hover:bg-background/60'>
                            <Pencil weight='bold' />
                          </span>
                        )}
                      </div>

                      {!loadingUpload &&
                        ((investor.owner_id && investor.owner_id == user?.id) ||
                          user?.roles === "admin-team" ||
                          hasAccess) && (
                          <input
                            type='file'
                            className='hidden'
                            id='hiddenFileInputSingle'
                          />
                        )}
                    </button>
                    <div className='flex flex-col items-center justify-center lg:justify-start lg:items-start'>
                      <div className='flex flex-wrap items-center gap-1.5'>
                        <Badge className='h-auto py-1'>Angel Investor</Badge>

                        {!!investor.is_inactive && (
                          <div className='relative group'>
                            <span className='inline-flex items-center justify-center rounded-full w-7 h-7 bg-gradient-to-tr from-red-700 to-red-400'>
                              <svg
                                xmlns='http://www.w3.org/2000/svg'
                                className='h-4 lg:h-[18px]'
                                viewBox='0 0 32 32'
                              >
                                <path
                                  fill='currentColor'
                                  d='M25.947 11.14c0-5.174-3.98-9.406-10.613-9.406S5.052 5.966 5.052 11.14s1.46 4.51 1.46 7.43c0 1.095-1.062.564-1.062 2.92c0 2.586 3.615 2.222 4.677 3.282c1.06 1.062.96 3.02.96 3.02s.2.795.565.562c0 0 .232.564.498.232c0 0 .265.563.53.1c0 0 .266.63.697.166c0 0 .43.63.93.133c0 0 .563.53 1.193.133c.63.397 1.194-.133 1.194-.133c.497.497.93-.133.93-.133c.43.465.694-.166.694-.166c.268.464.53-.1.53-.1c.267.332.5-.232.5-.232c.364.232.563-.563.563-.563s-.1-1.956.962-3.018c1.062-1.06 4.676-.696 4.676-3.283c0-2.355-1.06-1.825-1.06-2.92c0-2.92 1.46-2.256 1.46-7.43zm-15.614 9.852c-1.783.285-2.59-.215-2.785-1.492c-.508-3.328 2.555-3.866 4.08-3.683c.73.088 1.99.862 1.99 1.825c0 2.587-1.626 3.085-3.285 3.35m6.128 4.31c-.33 0-.86-.43-.894-1.226c-.033.796-.63 1.227-.96 1.227c-.333 0-.83-.33-.864-1.127c-.033-.796 1.028-4.013 1.792-4.013c.762 0 1.824 3.217 1.79 4.013s-.53 1.127-.863 1.127zm6.9-5.802c-.194 1.277-1.003 1.777-2.786 1.492c-1.658-.266-3.283-.763-3.283-3.35c0-.963 1.26-1.737 1.99-1.825c1.525-.183 4.59.355 4.08 3.683z'
                                />
                              </svg>
                            </span>
                            <span className='absolute px-2 py-1 text-xs text-white transition-opacity duration-200 transform -translate-x-1/2 bg-black rounded opacity-0 bottom-full left-1/2 group-hover:opacity-100'>
                              Inactive
                            </span>
                          </div>
                        )}

                        {investor.gender === "female" && (
                          <TooltipProvider>
                            <Tooltip>
                              <TooltipTrigger asChild>
                                <span className='inline-flex items-center justify-center -ml-1 w-7 h-7 bg-gradient-to-tr from-[#FF05B9] to-[#FF92E0] rounded-full ml-0.5'>
                                  <GenderFemale
                                    className='text-base text-white lg:text-lg'
                                    weight='bold'
                                  />
                                </span>
                              </TooltipTrigger>
                              <TooltipContent className='text-black bg-white'>
                                <p className='text-xs'>Female Angel Investor</p>
                              </TooltipContent>
                            </Tooltip>
                          </TooltipProvider>
                        )}
                      </div>
                      <h1 className='py-4 text-4xl font-bold leading-none tracking-tight text-center text-white lg:py-2 lg:text-5xl lg:text-left 2xl:text-6xl'>
                        {investor.name}
                      </h1>
                      <div className='flex flex-wrap justify-center lg:flex-nowrap'>
                        <p className='text-xs text-white lg:text-sm'>
                          <span className='text-white/60'>Angel Since</span>{" "}
                          {investor.year_established}
                        </p>
                        <p
                          className={`inline-flex items-center ml-2.5 lg:pl-3 pl-2.5 lg:ml-3 text-xs text-white border-l lg:text-sm border-white/20 ${
                            investor.city?.name ||
                            investor.country?.country_name
                              ? "opacity-100"
                              : "opacity-40"
                          }`}
                        >
                          <MapPin className='mr-1.5' />
                          {investor.city?.name && investor.country?.country_name
                            ? `${investor.city?.name}, ${investor.country?.country_name}`
                            : investor.country?.country_name || ""}
                        </p>

                        {investor.website && (
                          <a
                            href={investor.website}
                            target='_blank'
                            className='inline-flex items-center my-2 text-xs text-center text-white underline lg:my-0 lg:pl-3 lg:ml-3 lg:border-l lg:text-sm border-white/20'
                            rel='noreferrer noopener'
                          >
                            <Globe className='mr-1.5' />
                            Visit Website
                          </a>
                        )}
                        {JSON.stringify(socialMedias) !== "{}" && (
                          <div className='flex justify-center w-full space-x-2 lg:justify-start lg:w-auto lg:pl-3 lg:ml-3 lg:border-l border-white/20'>
                            {Object.entries(socialMedias)
                              .filter(([_, url]) => url) // Only show platforms with URLs
                              .map(([platform, url], index, arr) => (
                                <div
                                  key={platform}
                                  className='flex items-center space-x-2'
                                >
                                  <a
                                    href={url}
                                    target='_blank'
                                    className='inline-flex items-center text-xs text-white hover:underline lg:text-sm'
                                    rel='noreferrer'
                                  >
                                    {platform === "x"
                                      ? "X"
                                      : platform.charAt(0).toUpperCase() +
                                        platform.slice(1)}
                                  </a>
                                  {index < arr.length - 1 && (
                                    <span className='opacity-40'>&bull;</span>
                                  )}
                                </div>
                              ))}
                          </div>
                        )}
                      </div>
                      {user &&
                        (user.roles === "admin-team" ||
                          investor.owner_id === user?.id ||
                          hasAccess) && (
                          <div className='grid grid-cols-2 lg:flex gap-2.5 pt-10 w-full justify-center lg:justify-start'>
                            <TooltipProvider>
                              <Tooltip>
                                <TooltipTrigger>
                                  <div>
                                    {" "}
                                    {/* Wrap in div to avoid button nesting */}
                                    <Button
                                      type='button'
                                      onClick={scrollToPortfolio}
                                      className='w-full h-auto text-white border lg:w-auto bg-white/10 hover:bg-white/20 border-white/5'
                                    >
                                      <BuildingOffice className='mr-2 text-lg opacity-50' />
                                      Review Portfolio
                                    </Button>
                                  </div>
                                </TooltipTrigger>
                                <TooltipContent className='max-w-2xl text-xs font-normal text-left bg-white border-white text-background'>
                                  {`Don't forget to review your portfolio of investments periodically to add/remove startups that you are actively working with!`}
                                </TooltipContent>
                              </Tooltip>
                            </TooltipProvider>
                            <TooltipProvider>
                              <Tooltip>
                                <TooltipTrigger>
                                  <Button
                                    type='button'
                                    onClick={() =>
                                      router.push("/account/angel")
                                    }
                                    className='w-full h-auto text-white border lg:w-auto bg-white/10 hover:bg-white/20 border-white/5'
                                  >
                                    <Presentation
                                      weight='bold'
                                      className='mr-2 text-lg opacity-50'
                                    />
                                    Pitch Bank
                                  </Button>
                                </TooltipTrigger>
                                <TooltipContent className='max-w-2xl text-xs font-normal text-left bg-white border-white text-background'>
                                  You can view any pitch decks submitted by
                                  startups here, in your Pitch Bank.
                                </TooltipContent>
                              </Tooltip>
                            </TooltipProvider>
                            {user && investor.owner_id === user?.id && (
                              <TooltipProvider>
                                <Tooltip>
                                  <TooltipTrigger>
                                    <Button
                                      type='button'
                                      onClick={() =>
                                        router.push(
                                          "/account/access-angel-investor",
                                        )
                                      }
                                      className='w-full h-auto text-white border lg:w-auto bg-white/10 hover:bg-white/20 border-white/5'
                                    >
                                      <UserPlus className='mr-2 text-lg opacity-50' />
                                      Manage Access
                                    </Button>
                                  </TooltipTrigger>
                                  <TooltipContent className='max-w-2xl text-xs font-normal text-left bg-white border-white text-background'>
                                    You can manage who on your team has access
                                    to edit and receive deal flow by clicking on
                                    the Manage Access Button.
                                  </TooltipContent>
                                </Tooltip>
                              </TooltipProvider>
                            )}
                            <TooltipProvider>
                              <Tooltip>
                                <TooltipTrigger>
                                  <Button
                                    type='button'
                                    onClick={() =>
                                      router.push(
                                        `/angel-investors/${investor.slug}-${investor.id}/edit`,
                                      )
                                    }
                                    className='w-full h-auto text-white bg-gradient-to-tr from-blue-500 to-blue-400 lg:w-auto'
                                  >
                                    <Pen className='mr-2 text-lg opacity-50' />
                                    Edit Mode
                                  </Button>
                                </TooltipTrigger>
                                <TooltipContent className='max-w-2xl text-xs font-normal text-left bg-white border-white text-background'>
                                  {`You have access to edit ${investor.name}'s Angel Investor Page at LucidityInsights.com. With this access you can edit all investor information and keep it up to date for startups and investors to see.`}
                                </TooltipContent>
                              </Tooltip>
                            </TooltipProvider>
                          </div>
                        )}

                      {(!investor.owner_id || investor.owner_id != user?.id) &&
                        !hasAccess &&
                        user?.roles !== "admin-team" &&
                        !!investor.is_able_to_receive_pitch && (
                          <div className='lg:flex gap-2.5 pt-10 w-full justify-center lg:justify-start pl-[25%] lg:pl-0'>
                            <ApplyFunding
                              planSubscription={planSubscription}
                              investor={investor}
                              user={user}
                            />
                          </div>
                        )}
                    </div>
                  </div>

                  {/* <ApplyFunding
                  planSubscription={planSubscription}
                  investor={investor}
                  user={user}
                /> */}
                </div>
              </div>
            </div>
            <div className='container lg:flex'>
              <div className='flex-1 leading-relaxed lg:border-r lg:mr-6 border-white/10'>
                <div className='pb-5 lg:py-8 lg:pr-8 opacity-60'>
                  {investor.summary}
                </div>
                {showAngelSuperpower && (
                  <AngelSuperpowerPanel
                    sections={angelSuperpowerSections}
                    isOwner={isAngelOwner}
                    className='mt-6 mb-8 lg:hidden'
                  />
                )}
                <div className='grid-cols-12 col-span-8 divide-y lg:divide-x lg:grid divide-zinc-800'>
                  {investmentsByRegion.length > 0 && (
                    <div className='relative col-span-6 mt-5 lg:border-t lg:border-l lg:pt-6 lg:pb-12 lg:mt-0'>
                      {locked && (
                        <div className='absolute inset-0 z-10 w-full h-full bg-background/30 grayscale backdrop-blur-md'>
                          <LockedContent isLogin={user?.id} />
                        </div>
                      )}
                      <TooltipProvider>
                        <Tooltip>
                          <TooltipTrigger asChild>
                            <span className='absolute z-20 inline-block top-2.5 right-2.5 text-white'>
                              <Info size={20} />
                            </span>
                          </TooltipTrigger>
                          <TooltipContent className='max-w-lg text-xs font-normal text-left bg-white border-white text-background'>
                            <p>
                              This graph shows the breakdown of deals by
                              geographic region. Geographic region refers to
                              where the startup is currently headquartered. If
                              the startup moves HQ locations during its startup
                              journey, only the latest and current locations
                              startup HQ is considered.
                            </p>
                          </TooltipContent>
                        </Tooltip>
                      </TooltipProvider>
                      <div className='text-center'>
                        <h3
                          className={`font-medium leading-tight ${
                            locked
                              ? "z-10 absolute top-0 left-1/2 w-full -translate-x-1/2 mt-4 text-sm"
                              : "mb-5"
                          }`}
                        >
                          Funding Deals, by Region
                        </h3>
                        <div className='relative'>
                          <FundingRegionAngel
                            data={investmentsByRegion}
                            chartType='region'
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  {investmentsByFundingType.length > 0 && (
                    <div
                      className={`relative mt-5 py-5 lg:mt-0 lg:py-6 col-span-12 ${
                        investmentsByRegion.length > 0
                          ? "lg:col-span-6"
                          : "lg:col-span-9"
                      }`}
                    >
                      <TooltipProvider>
                        <Tooltip>
                          <TooltipTrigger asChild>
                            <span className='absolute z-20 inline-block top-2.5 right-2.5 text-white'>
                              <Info size={20} />
                            </span>
                          </TooltipTrigger>
                          <TooltipContent className='max-w-lg text-xs font-normal text-left bg-white border-white text-background'>
                            <p>
                              This refers to both the total number of deals this
                              investor (ie. VC, PE, Angel Group) has inked and
                              signed with startups, and the distribution of
                              these deals by growth stage (ie. Pre-seed to
                              Pre-IPO) of the startups this investor invests in.
                            </p>
                          </TooltipContent>
                        </Tooltip>
                      </TooltipProvider>
                      <div className='text-center'>
                        {locked && (
                          <div className='absolute inset-0 z-10 w-full h-full bg-background/30 grayscale backdrop-blur-md'>
                            <LockedContent isLogin={user?.id} />
                          </div>
                        )}
                        <h3
                          className={`font-medium leading-tight ${
                            locked
                              ? "z-10 absolute top-0 left-1/2 w-full -translate-x-1/2 mt-4 text-sm"
                              : "mb-5"
                          }`}
                        >
                          Current stage of startup invested in
                        </h3>
                        <div className='relative'>
                          <FundingRegionAngel
                            fundraised={investor.total_round_amount}
                            data={investmentsByFundingType}
                            chartType='funding-stage'
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  <div className='relative flex flex-col col-span-3'>
                    <div
                      className={`relative z-20 -mx-4 -mt-4 rounded-2xl text-background bg-white`}
                    >
                      <TooltipProvider>
                        <Tooltip>
                          <TooltipTrigger asChild>
                            <span className='absolute z-50 inline-block top-2.5 right-2.5 text-white'>
                              <Info size={20} />
                            </span>
                          </TooltipTrigger>
                          <TooltipContent className='max-w-lg text-xs font-normal text-left bg-white border-white text-background'>
                            <p>
                              This refers to the total number of startups the
                              investor (VC, PE, Angel Group, etc) has invested
                              in, and has equity in.
                            </p>
                          </TooltipContent>
                        </Tooltip>
                      </TooltipProvider>
                      <div className='py-8 text-center'>
                        <h3 className='mb-3 font-medium leading-tight'>
                          No. of Startup Invested In
                        </h3>
                        <span className='font-bold leading-none tracking-tighter text-7xl 2xl:text-8xl'>
                          {startups?.length || "-"}
                        </span>
                      </div>
                    </div>
                    <div className='flex items-center flex-1'>
                      <TooltipProvider>
                        <Tooltip>
                          <TooltipTrigger asChild>
                            <span className='absolute z-30 inline-block -top-1.5 -right-1.5 text-background'>
                              <Info size={20} />
                            </span>
                          </TooltipTrigger>
                          <TooltipContent className='max-w-lg text-xs font-normal text-left bg-white border-white text-background'>
                            <p>
                              This refers to the total number of startups the
                              investor (VC, PE, Angel Group, etc) has invested
                              in, and has equity in.
                            </p>
                          </TooltipContent>
                        </Tooltip>
                      </TooltipProvider>
                      <div className='flex flex-col justify-between h-full lg:p-6'>
                        <div className='flex-1'>
                          <Cardholder
                            weight='light'
                            className='mb-3 -ml-1.5 text-7xl opacity-20'
                          />
                          <p className='text-lg font-semibold'>USD</p>
                          <div className='text-5xl lg:text-3xl flex items-center justify-center lg:justify-start space-x-1 mt-1.5'>
                            <p className='font-bold tracking-tight text-transparent bg-gradient-to-r from-yellow-1 to-red-1 bg-clip-text lg:text-4xl'>
                              {formatNumber(investor.min_cheque_size)}
                            </p>
                            <p className='tracking-tight opacity-60'>-</p>
                            <p className='font-bold tracking-tight text-transparent bg-gradient-to-r from-yellow-1 to-red-1 bg-clip-text lg:text-4xl'>
                              {formatNumber(investor.max_cheque_size)}
                            </p>
                          </div>
                        </div>
                        <h3 className='mt-2 font-medium leading-tight lg:mt-0'>
                          Average Cheque Size
                        </h3>
                      </div>
                    </div>
                  </div>
                  {counter && (
                    <div className='relative col-span-9 pt-6 mt-5 lg:p-6 lg:mt-0'>
                      <TooltipProvider>
                        <Tooltip>
                          <TooltipTrigger asChild>
                            <span className='absolute z-20 inline-block top-2.5 right-2.5 text-white'>
                              <Info size={20} />
                            </span>
                          </TooltipTrigger>
                          <TooltipContent className='max-w-lg text-xs font-normal text-left bg-white border-white text-background'>
                            <p>
                              This graph shows the number of deals this investor
                              has signed each year.
                            </p>
                          </TooltipContent>
                        </Tooltip>
                      </TooltipProvider>
                      {investmentsByYear.length > 0 && (
                        <div className='relative w-full text-center'>
                          {locked && (
                            <div className='absolute inset-0 z-10 w-full h-full bg-background/30 grayscale backdrop-blur-md'>
                              <LockedContent isLogin={user?.id} />
                            </div>
                          )}
                          <h3
                            className={`font-medium leading-tight ${
                              locked
                                ? "z-10 absolute top-0 left-1/2 w-full -translate-x-1/2 mt-4 text-sm"
                                : "mb-5"
                            }`}
                          >
                            Total No. of Investments Globally, by Year
                          </h3>
                          <div className='relative'>
                            <InvestmentChart
                              data={investmentsByYear}
                              locked={locked}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                  {vcFunds.length > 0 && (
                    <div className='relative col-span-12 pt-10 -mx-4 lg:mx-0'>
                      {locked && (
                        <div className='absolute inset-0 z-20 w-full h-full bg-background/30 grayscale backdrop-blur-md'>
                          <LockedContent isLogin={user?.id} />
                        </div>
                      )}
                      <h3
                        className={`font-bold text-center text-white leading-tight ${
                          locked
                            ? "z-30 absolute top-0 left-1/2 text-center w-full -translate-x-1/2 mt-4 text-sm"
                            : "text-2xl lg:text-4xl"
                        }`}
                      >
                        Funds Raised
                      </h3>
                      <div className='grid grid-cols-12 pt-6 text-sm'>
                        {/* Empty */}
                        {/* Data */}
                        <div className='col-span-12'>
                          <div className='flex justify-center px-4 py-4 space-x-6 lg:space-x-12 border-y lg:px-5 bg-white/5 border-white/5'>
                            <div className='flex items-center space-x-2 lg:space-x-2.5'>
                              <span className='text-2xl font-semibold tracking-tight lg:text-5xl'>
                                {vcFunds.length}
                              </span>
                              <span className='text-xs font-medium lg:text-base'>
                                Fund{vcFunds.length > 1 ? "s" : ""} in Total
                              </span>
                            </div>
                            <div className='flex items-center space-x-2 lg:space-x-2.5'>
                              <span className='text-2xl font-semibold tracking-tight lg:text-5xl'>
                                $
                                {vcFunds.length > 0
                                  ? formatNumber(
                                      vcFunds.reduce(
                                        (a, b) => a + b.fund_size,
                                        0,
                                      ),
                                    )
                                  : 0}
                              </span>
                              <span className='text-xs font-medium lg:text-base'>
                                Total Fund Raised
                              </span>
                            </div>
                          </div>
                          <ScrollArea className='hidden lg:block'>
                            <div className='max-h-80'>
                              <Table className='text-base'>
                                <TableHeader className='sticky top-0 bg-black z-2'>
                                  <TableRow>
                                    <TableHead className='w-[160px] pl-4 lg:pl-5'>
                                      Fund Name
                                    </TableHead>
                                    <TableHead className='text-right'>
                                      Fund Size
                                    </TableHead>
                                    <TableHead>Fund Type</TableHead>
                                    <TableHead className='text-right'>
                                      Announced Date
                                    </TableHead>
                                    <TableHead>Status</TableHead>
                                  </TableRow>
                                </TableHeader>
                                <TableBody>
                                  {vcFunds.map((vcFund, i) => (
                                    <TableRow
                                      key={`vc-fund-vc-detail-${vcFund.id}`}
                                    >
                                      <TableCell className='py-3 pl-4 font-medium lg:pl-5'>
                                        {vcFund.fund_name}
                                      </TableCell>
                                      <TableCell className='py-3 text-xl font-semibold text-right'>
                                        ${formatNumber(vcFund.fund_size)}
                                      </TableCell>
                                      <TableCell className='py-3'>
                                        {
                                          INVESTOR_TYPES.find(
                                            (vc_type) =>
                                              vc_type.value ===
                                              vcFund.fund_type,
                                          )?.label
                                        }
                                      </TableCell>
                                      <TableCell className='py-3 text-right'>
                                        {dayjs(vcFund.date_raised).format(
                                          "MMM DD, YYYY",
                                        )}
                                      </TableCell>
                                      <TableCell className='py-3'>
                                        {unslugify(vcFund.status)}
                                      </TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            </div>
                          </ScrollArea>
                        </div>
                      </div>
                    </div>
                  )}

                  <div
                    id='portfolio-startups'
                    className='relative col-span-12 lg:pr-6 pl-0 py-6 lg:py-12 !border-l-0'
                  >
                    <section id='portfolio' className='scroll-mt-[104px]'>
                      <div className='flex items-end justify-between'>
                        <h2
                          className={`font-bold leading-tight tracking-tight ${
                            locked
                              ? "z-30 absolute top-0 left-1/2 text-center w-full -translate-x-1/2 mt-4 text-sm"
                              : "lg:mb-1.5 text-3xl lg:text-5xl"
                          }`}
                        >
                          Portfolio Companies <br className='2xl:hidden' /> or
                          Investments
                        </h2>
                        {user &&
                          startups?.length > 0 &&
                          isEdit &&
                          (investor.owner_id == user.id ||
                            user.roles === "admin-team" ||
                            hasAccess) && (
                            <HoverCard open={true}>
                              <HoverCardTrigger>
                                <div className='flex-shrink-0 relative w-14 lg:w-28 hidden lg:inline-block aspect-[199/320]'>
                                  <Image
                                    src={LucidMascot.src}
                                    alt=''
                                    layout={"fill"}
                                    objectFit={"cover"}
                                  />
                                </div>
                              </HoverCardTrigger>
                              <HoverCardContent
                                side='left'
                                sideOffset={16}
                                className='hidden !z-10 lg:flex px-2 lg:px-3 py-2 lg:py-4 w-[280px] lg:w-[440px] rounded-lg bg-white/90 backdrop-blur-sm text-background'
                              >
                                <Info className='flex-shrink-0 w-6 h-6 mr-3 translate-y-0.5' />
                                <div>
                                  <p className='text-lg font-bold'>Heads Up!</p>
                                  <p className='mt-1 mb-3 text-xs lg:text-sm opacity-70'>
                                    {`Don't forget to review your portfolio of investments periodically to add/remove startups that you are actively working with!`}
                                  </p>
                                  <ReviewStartup
                                    addStartupId={addStartupId}
                                    startups={startups}
                                    portfolioData={portfolioData}
                                    checkedStartups={checkedStartups}
                                    onVerify={onVerify}
                                    onUnVerify={onUnVerify}
                                    onArchive={onArchive}
                                    onRestore={onRestore}
                                    setCheckedStartups={setCheckedStartups}
                                    checkAllRef={checkAllRef}
                                    addAll={addAll}
                                  />
                                </div>
                              </HoverCardContent>
                            </HoverCard>
                          )}
                      </div>

                      <div className='z-10 h-full'>
                        {/* {locked && (
                    <div className='absolute inset-0 z-20 w-full h-full bg-background/30 grayscale backdrop-blur-md'>
                      <LockedContent isLogin={user?.id} />
                    </div>
                  )} */}
                        <div className='lg:flex items-center py-3 lg:space-x-3 top-[120px] lg:top-40 bg-background/90 backdrop-blur'>
                          <div className='relative flex-1 overflow-hidden rounded-md'>
                            <div className='absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none'>
                              <MagnifyingGlass
                                className='w-4 h-4 text-white/40'
                                aria-hidden='true'
                              />
                            </div>
                            <form onSubmit={onSearchPortfolios}>
                              <input
                                type='text'
                                className='block w-full border-none placeholder:text-white/40 hover:bg-zinc-800 transition-colors duration-200 pl-9 py-2.5 bg-white/5 border-white/5 focus:ring-white/20 sm:text-sm'
                                placeholder='Search...'
                                value={startupInput}
                                onChange={(e) =>
                                  setStartupInput(e.target.value)
                                }
                              />
                            </form>
                          </div>
                          {user &&
                            isEdit &&
                            (investor.owner_id == user.id ||
                              user.roles === "admin-team" ||
                              hasAccess) && (
                              <AddStartup
                                investorId={investorId}
                                portfolios={startups}
                                isAngelInvestor={investor.is_angel}
                              />
                            )}
                        </div>
                        <div className='flex flex-wrap gap-1.5'>
                          <Popover modal={true}>
                            <PopoverTrigger asChild>
                              <Button
                                type='button'
                                onClick={() => setSearchQuery("")}
                                className='h-auto hover:bg-white/10 py-1 pl-2.5 pr-1 text-xs font-medium border border-dashed rounded-full hover:bg-background bg-background border-white/20 text-white/60'
                              >
                                Countries
                                {temps?.countries.length > 0 ? (
                                  <span className='font-medium text-orange-1 flex pl-1.5 ml-1.5 border-l border-white/20'>
                                    {temps.countries.length > 3 ? (
                                      <>
                                        {temps.countries
                                          .slice(0, 3)
                                          .map(
                                            (country) =>
                                              countries.find(
                                                (s) => s.id == country.id,
                                              )?.country_name,
                                          )
                                          .join(", ")}
                                        , +{temps.countries.length - 3}
                                      </>
                                    ) : (
                                      temps.countries
                                        .map(
                                          (country) =>
                                            countries.find(
                                              (s) => s.id == country.id,
                                            )?.country_name,
                                        )
                                        .join(", ")
                                    )}
                                  </span>
                                ) : (
                                  <span className='font-medium text-orange-1 flex pl-1.5 ml-1.5 border-l border-white/20 mr-1.5'>
                                    All
                                  </span>
                                )}
                                {temps?.countries.length > 0 && (
                                  <div
                                    className='cursor-pointer h-auto p-0.5 m-0 ml-1.5 text-white group bg-transparent border border-dashed rounded-full border-white/40 hover:bg-white/20'
                                    onClick={(e) =>
                                      removeFilter(e, "countries")
                                    }
                                  >
                                    <X
                                      className='text-white/70 group-hover:text-white text-[9px]'
                                      weight='bold'
                                    />
                                  </div>
                                )}
                              </Button>
                            </PopoverTrigger>
                            <PopoverContent
                              align='start'
                              className='p-0 overflow-hidden origin-left bg-white text-background border-background/20'
                            >
                              <div className='p-1.5 border-b border-gray-200'>
                                <Input
                                  placeholder="Search for 'Country'"
                                  className='bg-white shadow-sm text-background border-background/20 focus-visible:ring-0'
                                  value={searchQuery}
                                  onChange={(e) =>
                                    setSearchQuery(e.target.value)
                                  }
                                />
                              </div>
                              <div className='overflow-y-auto max-h-56'>
                                {filteredCountries.map((country, index) => (
                                  <Label
                                    key={`country-${country.id}`}
                                    className='flex items-start gap-2 px-2.5 py-[7px] leading-none text-left cursor-pointer hover:bg-gray-100'
                                  >
                                    <Checkbox
                                      checked={
                                        !!temps?.countries.find(
                                          (d) =>
                                            String(d.id) == String(country.id),
                                        )
                                      }
                                      onCheckedChange={(event) =>
                                        handleChangeFilter(
                                          "countries",
                                          event,
                                          country,
                                        )
                                      }
                                      id={`country-${country.id}`}
                                      className='bg-white border shadow border-background/20'
                                    />
                                    <span className='font-normal translate-y-px'>
                                      {country.country_name}
                                      <span className='ml-1 text-xs opacity-50'>
                                        ({country.prefix})
                                      </span>
                                    </span>
                                  </Label>
                                ))}
                              </div>
                            </PopoverContent>
                          </Popover>
                          <Popover modal={true}>
                            <PopoverTrigger asChild>
                              <Button
                                type='button'
                                onClick={() => setSectorSearch("")}
                                className='h-auto hover:bg-white/10 py-1 pl-2.5 pr-1 text-xs font-medium border border-dashed rounded-full hover:bg-background bg-background border-white/20 text-white/60'
                              >
                                Sectors
                                {temps?.sectors.length > 0 ? (
                                  <span className='font-medium text-orange-1 flex pl-1.5 ml-1.5 border-l border-white/20'>
                                    {temps.sectors.length > 3 ? (
                                      <>
                                        {temps.sectors
                                          .slice(0, 3)
                                          .map(
                                            (sector) =>
                                              sectors.find(
                                                (s) => s.id == sector.id,
                                              )?.name,
                                          )
                                          .join(", ")}
                                        , +{temps.sectors.length - 3}
                                      </>
                                    ) : (
                                      temps.sectors
                                        .map(
                                          (sector) =>
                                            sectors.find(
                                              (s) => s.id == sector.id,
                                            )?.name,
                                        )
                                        .join(", ")
                                    )}
                                  </span>
                                ) : (
                                  <span className='font-medium text-orange-1 flex pl-1.5 ml-1.5 border-l border-white/20 mr-1.5'>
                                    All
                                  </span>
                                )}
                                {temps?.sectors.length > 0 && (
                                  <div
                                    className='cursor-pointer h-auto p-0.5 m-0 ml-1.5 text-white group bg-transparent border border-dashed rounded-full border-white/40 hover:bg-white/20'
                                    onClick={(e) => removeFilter(e, "sectors")}
                                  >
                                    <X
                                      className='text-white/70 group-hover:text-white text-[9px]'
                                      weight='bold'
                                    />
                                  </div>
                                )}
                              </Button>
                            </PopoverTrigger>
                            <PopoverContent
                              align='start'
                              className='p-0 overflow-hidden bg-white text-background border-background/20'
                            >
                              <div className='p-1.5 border-b border-gray-200'>
                                <Input
                                  placeholder="Search for 'Sector'"
                                  className='bg-white shadow-sm text-background border-background/20 focus-visible:ring-0'
                                  value={sectorSearch}
                                  onChange={(e) =>
                                    setSectorSearch(e.target.value)
                                  }
                                />
                              </div>
                              <div className='overflow-y-auto max-h-56'>
                                {filteredSectors
                                  .filter((s) => s.name)
                                  .map((sector, index) => (
                                    <Label
                                      key={`sector-${sector.id}`}
                                      className='flex items-start gap-2 px-2.5 py-[7px] leading-none text-left cursor-pointer hover:bg-gray-100'
                                    >
                                      <Checkbox
                                        checked={
                                          !!temps?.sectors.find(
                                            (d) =>
                                              String(d.id) == String(sector.id),
                                          )
                                        }
                                        onCheckedChange={(event) =>
                                          handleChangeFilter(
                                            "sectors",
                                            event,
                                            sector,
                                          )
                                        }
                                        id={`sector-${sector.id}`}
                                        className='bg-white border shadow border-background/20'
                                      />
                                      <span className='font-normal translate-y-px'>
                                        {sector.name}
                                      </span>
                                    </Label>
                                  ))}
                              </div>
                            </PopoverContent>
                          </Popover>

                          <Popover modal={true}>
                            <PopoverTrigger asChild>
                              <Button
                                type='button'
                                onClick={() => setStageSearch("")}
                                className='h-auto hover:bg-white/10 py-1 pl-2.5 pr-1 text-xs font-medium border border-dashed rounded-full hover:bg-background bg-background border-white/20 text-white/60'
                              >
                                Stages
                                {temps?.stages.length > 0 ? (
                                  <span className='font-medium text-orange-1 flex pl-1.5 ml-1.5 border-l border-white/20'>
                                    {temps.stages.length > 3 ? (
                                      <>
                                        {temps.stages
                                          .slice(0, 3)
                                          .map(
                                            (stage) =>
                                              stages.find(
                                                (s) => s.id == stage.id,
                                              )?.name,
                                          )
                                          .join(", ")}
                                        , +{temps.stages.length - 3}
                                      </>
                                    ) : (
                                      temps.stages
                                        .map(
                                          (stage) =>
                                            stages.find((s) => s.id == stage.id)
                                              ?.name,
                                        )
                                        .join(", ")
                                    )}
                                  </span>
                                ) : (
                                  <span className='font-medium text-orange-1 flex pl-1.5 ml-1.5 border-l border-white/20 mr-1.5'>
                                    All
                                  </span>
                                )}
                                {temps?.stages.length > 0 && (
                                  <div
                                    className='cursor-pointer h-auto p-0.5 m-0 ml-1.5 text-white group bg-transparent border border-dashed rounded-full border-white/40 hover:bg-white/20'
                                    onClick={(e) => removeFilter(e, "stages")}
                                  >
                                    <X
                                      className='text-white/70 group-hover:text-white text-[9px]'
                                      weight='bold'
                                    />
                                  </div>
                                )}
                              </Button>
                            </PopoverTrigger>
                            <PopoverContent className='p-0 overflow-hidden bg-white text-background border-background/20'>
                              <div className='p-1.5 border-b border-gray-200'>
                                <Input
                                  placeholder="Search for 'Stage'"
                                  className='bg-white shadow-sm text-background border-background/20 focus-visible:ring-0'
                                  value={stageSearch}
                                  onChange={(e) =>
                                    setStageSearch(e.target.value)
                                  }
                                />
                              </div>
                              <div className='overflow-y-auto max-h-56'>
                                {filteredStages.map((stage, index) => (
                                  <Label
                                    key={`stage-${stage.id}`}
                                    className='flex items-start gap-2 px-2.5 py-[7px] leading-none text-left cursor-pointer hover:bg-gray-100'
                                  >
                                    <Checkbox
                                      checked={
                                        !!temps?.stages.find(
                                          (d) =>
                                            String(d.id) == String(stage.id),
                                        )
                                      }
                                      onCheckedChange={(event) =>
                                        handleChangeFilter(
                                          "stages",
                                          event,
                                          stage,
                                        )
                                      }
                                      id={`stage-${stage.id}`}
                                      className='bg-white border shadow border-background/20'
                                    />
                                    <span className='font-normal translate-y-px'>
                                      {stage.name}
                                    </span>
                                  </Label>
                                ))}
                              </div>
                            </PopoverContent>
                          </Popover>

                          {(temps.countries.length > 0 ||
                            temps.sectors.length > 0 ||
                            temps.stages.length > 0) && (
                            <Button
                              type='button'
                              onClick={onClearFilter}
                              className='h-auto px-2 py-0 text-xs text-red-500 bg-transparent hover:bg-transparent hover:underline hover:text-red-500'
                            >
                              Clear all filters
                            </Button>
                          )}
                        </div>
                        <div>
                          {!showMap && (
                            <>
                              {locked && (
                                <div className='absolute inset-0 w-full h-full bg-background/30 grayscale backdrop-blur-md'>
                                  <LockedContent isLogin={user?.id} />
                                </div>
                              )}
                              <div className='pt-4 pb-2 border-b lg:pb-3'>
                                <div className='flex items-center'>
                                  <p className='text-xs font-medium lg:text-sm'>
                                    Showing{" "}
                                    {
                                      startups?.filter(
                                        (s) =>
                                          !portfolioData.archived.includes(
                                            s.id,
                                          ),
                                      ).length
                                    }{" "}
                                    Results
                                  </p>
                                  {user &&
                                    isEdit &&
                                    (investor.owner_id == user.id ||
                                      user.roles === "admin-team" ||
                                      hasAccess) && (
                                      <Dialog>
                                        <DialogTrigger asChild>
                                          <Button
                                            type='button'
                                            variant='link'
                                            className='h-auto p-0 m-0 ml-auto'
                                          >
                                            <WarningCircle className='mr-1.5' />
                                            Report
                                          </Button>
                                        </DialogTrigger>
                                        <DialogContent className='bg-white text-background'>
                                          <DialogHeader>
                                            <DialogTitle>
                                              Report Startups
                                            </DialogTitle>
                                            <DialogDescription className='text-background/60'>
                                              <p className='mt-2'>
                                                If you discover any inaccuracies
                                                in the startup data, please feel
                                                free to report them to us.
                                              </p>
                                              <div className='grid flex-1 grid-cols-12 mt-5 gap-x-3 gap-y-4'>
                                                <div className='w-full col-span-12 space-y-1.5'>
                                                  <Label
                                                    className='text-xs text-background'
                                                    htmlFor='job_title'
                                                  >
                                                    Message
                                                  </Label>
                                                  <Textarea
                                                    id='testimonial'
                                                    rows={6}
                                                    className='bg-white text-background border-background/20 focus-visible:ring-0'
                                                  />
                                                </div>
                                                <Button
                                                  size={"lg"}
                                                  className='col-span-12 font-medium'
                                                  variant='secondary'
                                                  type='button'
                                                >
                                                  Report
                                                </Button>
                                              </div>
                                            </DialogDescription>
                                          </DialogHeader>
                                        </DialogContent>
                                      </Dialog>
                                    )}
                                </div>
                              </div>
                              <div className=''>
                                <div className='grid grid-cols-1 gap-5 mt-4 lg:grid-cols-3 2xl:grid-cols-4'>
                                  {locked ? (
                                    <>
                                      {loadingPortfolios ? (
                                        <p className='text-sm'>Loading...</p>
                                      ) : (
                                        startups
                                          ?.slice(0, 4)
                                          .filter((s) => s.is_published)
                                          // .sort((a, b) => a.name.localeCompare(b.name))
                                          .map((portfolio) => (
                                            <PortfolioCard
                                              hasSubscription={hasSubscription}
                                              user={user}
                                              vc_startup_news={vc_startup_news}
                                              portfolio={portfolio}
                                              portfolioData={portfolioData}
                                              checkedStartups={checkedStartups}
                                              addStartupId={addStartupId}
                                              key={`portfolio-${portfolio.id}`}
                                              onClick={
                                                portfolio.is_published
                                                  ? () =>
                                                      router.push(
                                                        `/startups/${portfolio.slug}-${portfolio.id}`,
                                                      )
                                                  : () =>
                                                      handleSelectStartup(
                                                        portfolio,
                                                      )
                                              }
                                              isEdit={isEdit}
                                            />
                                          ))
                                      )}
                                    </>
                                  ) : (
                                    <>
                                      {loadingPortfolios ? (
                                        <p>Loading...</p>
                                      ) : (
                                        startups
                                          ?.filter(
                                            (s) =>
                                              s.is_published &&
                                              !portfolioData.archived.includes(
                                                s.id,
                                              ),
                                          )
                                          // .sort((a, b) => a.name.localeCompare(b.name))
                                          .map((portfolio) => (
                                            <PortfolioCard
                                              hasSubscription={hasSubscription}
                                              user={user}
                                              vc_startup_news={vc_startup_news}
                                              portfolio={portfolio}
                                              portfolioData={portfolioData}
                                              key={`portfolio-${portfolio.id}`}
                                              checkedStartups={checkedStartups}
                                              addStartupId={addStartupId}
                                              onClick={
                                                portfolio.is_published
                                                  ? () =>
                                                      router.push(
                                                        `/startups/${portfolio.slug}-${portfolio.id}`,
                                                      )
                                                  : () =>
                                                      handleSelectStartup(
                                                        portfolio,
                                                      )
                                              }
                                              isEdit={isEdit}
                                            />
                                          ))
                                      )}
                                    </>
                                  )}

                                  {!locked && (
                                    <>
                                      {!loadingPortfolios &&
                                        startups
                                          ?.filter(
                                            (s) =>
                                              !s.is_published &&
                                              !portfolioData.archived.includes(
                                                s.id,
                                              ),
                                          )
                                          // .sort((a, b) => a.name.localeCompare(b.name))
                                          .map((portfolio) => (
                                            <PortfolioCard
                                              hasSubscription={hasSubscription}
                                              user={user}
                                              vc_startup_news={vc_startup_news}
                                              portfolio={portfolio}
                                              portfolioData={portfolioData}
                                              key={`portfolio-${portfolio.id}`}
                                              checkedStartups={checkedStartups}
                                              addStartupId={addStartupId}
                                              onClick={
                                                portfolio.is_published
                                                  ? () =>
                                                      router.push(
                                                        `/startups/${portfolio.slug}-${portfolio.id}`,
                                                      )
                                                  : () =>
                                                      handleSelectStartup(
                                                        portfolio,
                                                      )
                                              }
                                              isEdit={isEdit}
                                            />
                                          ))}
                                      {currentPage < lastPage && (
                                        <button onClick={loadMore}>
                                          loadMore
                                        </button>
                                      )}
                                    </>
                                  )}
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      </div>

                      {showMap && (
                        <div className='mt-8'>
                          <PortfolioMap
                            startups={startups}
                            handleSelectStartup={handleSelectStartup}
                          />
                        </div>
                      )}
                    </section>
                  </div>
                </div>
              </div>
              <div className='relative z-10 lg:w-[320px] space-y-6 lg:space-y-10 pb-16'>
                {showAngelSuperpower && (
                  <AngelSuperpowerPanel
                    sections={angelSuperpowerSections}
                    isOwner={isAngelOwner}
                    className='hidden lg:block'
                  />
                )}

                {investor.twitter_url && (
                  <div>
                    <p className='pb-2 text-xl font-semibold border-b lg:text-lg border-white/10'>
                      {investor.name} X Feeds
                    </p>
                    <TwitterFeed twitterUrl={investor.twitter_url} />
                  </div>
                )}

                <RelatedContentSidebar
                  title='Related Videos'
                  entity={{
                    type: "venture-capital",
                    id: investorId,
                  }}
                  contentType={CONTENT_TYPES.VIDEOS}
                />
                <RelatedContentSidebar
                  title='Did you check these out?'
                  entity={{
                    type: "venture-capital",
                    id: investorId,
                    name: investor.name,
                  }}
                />
              </div>
            </div>
          </div>

          {selectedStartup && isOpen && (
            <StartupModalDetail
              {...{ isOpen, setIsOpen, selectedStartup, setSelectedStartup }}
            />
          )}
          <WishlistAddNew
            addWishlistCategory={addWishlistCategory}
            id={investor.id}
            type={2}
            isOpen={isAddDialogOpen}
            setIsOpen={setIsAddDialogOpen}
            wishlistCategories={wishlistCategories}
            hasSubscription={hasSubscription}
          />
        </div>
      </div>

      {showSuccessModal && (
        <PublishSuccess
          open={showSuccessModal}
          setOpen={handleCloseSuccessModal}
          type='angel'
        />
      )}
    </Layout>
  );
};

export async function getServerSideProps({ params, req }) {
  // Get the IP address from the request headers or connection
  const userIp = req.headers["x-forwarded-for"] || req.connection.remoteAddress;

  // Fetch data from external API
  const id = params.slug.split("-").pop();
  const res = await getInvestorDetail(id);
  const data = res.data;

  const resPortfolios = await getInvestorPortfolios(id, {
    params: {
      per_page: 1000,
    },
  });

  const portfolios = resPortfolios.data.startups;
  const addedPortfolios = resPortfolios.data.portfolios;
  portfolios["data"] = [...portfolios.data, ...addedPortfolios];
  const startup_sectors = resPortfolios.data.startup_sectors;
  const top_n_sectors = resPortfolios.data.top_n_sectors;
  const vc_startup_news = resPortfolios.data.vc_startup_news;

  const resRelated = await getInvestorRelated(id);

  const related = resRelated.data;

  const byYearRes = await getInvestmentByYear(id);
  const byRegionRes = await getInvestmentByRegion(id);
  const byFundingTypeRed = await getInvestmentByCurrentStage(id);

  // Pass data to the page via props
  return {
    props: {
      investor: data,
      portfolios: portfolios || [],
      investorId: id,
      related,
      investmentsByYear: byYearRes.data,
      investmentsByRegion: byRegionRes.data,
      investmentsByFundingType: byFundingTypeRed.data,
      startup_sectors,
      top_n_sectors,
      vc_startup_news,
    },
  };
}

export default VentureCapitalDetail;
